import { v4 as uuidv4 } from 'uuid'
import { genPrompt } from '@/api/prompt'
import { genOssImage } from '@/utils/ossPath'
import { Message } from 'element-ui'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import random from 'random'
import ImageGallery from '@/utils/gallery_list'
import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET, BAIDU_TRANSLATE_API_KEY } from '@/utils/secretCrypto'
/**
 * @description:这是一个SDXL通用美甲的执行算法
 * @param {string} galleryname // 图库参数有两个'cateyesxl'&&'dazahuisdxl'
 * @param {string} positive // 输入正向提示词参数
 */

function commonsdxl(galleryname, positive, genParam, progressCallback) {
  return new Promise((resolve, reject) => {
    const imageList = []
    let num = null
    let ImageList = null
    // 选图库
    if (galleryname === 'cateyesxl') {
      num = Math.floor(Math.random() * 25) + 1
      ImageList = ImageGallery.cateyessdxl()
    }
    if (galleryname === 'dazahuisdxl') {
      num = Math.floor(Math.random() * 49) + 1
      ImageList = ImageGallery.commonsdxl()
    }
    const iamge2iamgepath = ImageList[num]
    // 获取随机数
    const seed = Math.floor(Math.random() * 100000000000000)
    const filename_1 = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const filename_2 = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const filename_3 = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const filename_4 = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const promptData = {
      3: {
        inputs: {
          seed: seed,
          steps: genParam.steps,
          cfg: genParam.cfg,
          sampler_name: 'euler',
          scheduler: 'normal',
          denoise: 0.5000000000000000,
          model: [
            '11',
            0
          ],
          positive: [
            '13',
            0
          ],
          negative: [
            '12',
            0
          ],
          latent_image: [
            '65',
            0
          ]
        },
        class_type: 'KSampler',
        _meta: {
          title: 'KSampler'
        }
      },
      4: {
        inputs: {
          ckpt_name: 'SDXL/XL极致写实 _ 万物摄影 _ FLUX模拟器_V1.safetensors'
        },
        class_type: 'CheckpointLoaderSimple',
        _meta: {
          title: 'Load Checkpoint'
        }
      },
      8: {
        inputs: {
          samples: [
            '3',
            0
          ],
          vae: [
            '4',
            2
          ]
        },
        class_type: 'VAEDecode',
        _meta: {
          title: 'VAE Decode'
        }
      },
      11: {
        inputs: {
          lora_name: 'Flux_MJ/Flux_CatEyesV1.0_rank16_bf16.safetensors',
          strength_model: genParam.weight,
          strength_clip: 1.0000000000000000,
          model: [
            '4',
            0
          ],
          clip: [
            '4',
            1
          ]
        },
        class_type: 'LoraLoader',
        _meta: {
          title: 'Load LoRA'
        }
      },
      12: {
        inputs: {
          text: [
            '59',
            0
          ],
          token_normalization: 'none',
          weight_interpretation: 'Stable diffusion',
          clip: [
            '11',
            1
          ]
        },
        class_type: 'AC_Stable Diffusion格式提示词',
        _meta: {
          title: 'AC_Stable Diffusion格式提示词'
        }
      },
      13: {
        inputs: {
          text: [
            '29',
            0
          ],
          token_normalization: 'none',
          weight_interpretation: 'Stable diffusion',
          clip: [
            '11',
            1
          ]
        },
        class_type: 'AC_Stable Diffusion格式提示词',
        _meta: {
          title: 'AC_Stable Diffusion格式提示词'
        }
      },
      28: {
        inputs: {
          text: positive,
          translate_from: 'zh',
          translate_to: 'en',
          APIID: '20250612002379955',
          APIKEY: BAIDU_TRANSLATE_API_KEY
        },
        class_type: 'AC_百度翻译',
        _meta: {
          title: 'AC_百度翻译'
        }
      },
      29: {
        inputs: {
          boolean: true,
          on_true: [
            '28',
            0
          ],
          on_false: [
            '30',
            0
          ]
        },
        class_type: 'easy ifElse',
        _meta: {
          title: 'If else'
        }
      },
      30: {
        inputs: {
          text: [
            '66',
            0
          ]
        },
        class_type: 'Nodepad_啊程记事本',
        _meta: {
          title: 'Nodepad_啊程记事本'
        }
      },
      35: {
        inputs: {
          images: [
            '8',
            0
          ]
        },
        class_type: 'ImageListToImageBatch',
        _meta: {
          title: 'Image List to Image Batch'
        }
      },
      47: {
        inputs: {
          index: 0,
          any: [
            '35',
            0
          ]
        },
        class_type: 'easy indexAnything',
        _meta: {
          title: 'Index Any'
        }
      },
      48: {
        inputs: {
          index: 1,
          any: [
            '35',
            0
          ]
        },
        class_type: 'easy indexAnything',
        _meta: {
          title: 'Index Any'
        }
      },
      49: {
        inputs: {
          index: 2,
          any: [
            '35',
            0
          ]
        },
        class_type: 'easy indexAnything',
        _meta: {
          title: 'Index Any'
        }
      },
      50: {
        inputs: {
          index: 3,
          any: [
            '35',
            0
          ]
        },
        class_type: 'easy indexAnything',
        _meta: {
          title: 'Index Any'
        }
      },
      51: {
        inputs: {
          filename: filename_1,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '47',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      },
      55: {
        inputs: {
          filename: filename_2,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '48',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      },
      56: {
        inputs: {
          filename: filename_3,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '49',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      },
      57: {
        inputs: {
          filename: filename_4,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '50',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      },
      58: {
        inputs: {
          filename_prefix: 'ComfyUI',
          images: [
            '8',
            0
          ]
        },
        class_type: 'SaveImage',
        _meta: {
          title: 'Save Image'
        }
      },
      59: {
        inputs: {
          ModeList: '通用反向-001.txt'
        },
        class_type: 'AC_Negative_prompt提示词',
        _meta: {
          title: 'AC_Negative_prompt提示词'
        }
      },
      60: {
        inputs: {
          image: 'example.png'
        },
        class_type: 'LoadImage',
        _meta: {
          title: 'Load Image'
        }
      },
      61: {
        inputs: {
          boolean: false,
          on_true: [
            '60',
            0
          ],
          on_false: [
            '62',
            0
          ]
        },
        class_type: 'easy ifElse',
        _meta: {
          title: 'If else'
        }
      },
      62: {
        inputs: {
          image_url: iamge2iamgepath
        },
        class_type: 'AC_从URL加载图像',
        _meta: {
          title: 'AC_从URL加载图像'
        }
      },
      63: {
        inputs: {
          pixels: [
            '61',
            0
          ],
          vae: [
            '4',
            2
          ]
        },
        class_type: 'VAEEncode',
        _meta: {
          title: 'VAE Encode'
        }
      },
      64: {
        inputs: {
          upscale_method: 'nearest-exact',
          width: genParam.absWidth,
          height: genParam.absWidth,
          crop: 'center',
          samples: [
            '63',
            0
          ]
        },
        class_type: 'LatentUpscale',
        _meta: {
          title: 'Upscale Latent'
        }
      },
      65: {
        inputs: {
          amount: 4,
          samples: [
            '64',
            0
          ]
        },
        class_type: 'RepeatLatentBatch',
        _meta: {
          title: 'Repeat Latent Batch'
        }
      },
      66: {
        inputs: {
          model: 'wd-v1-4-moat-tagger-v2',
          threshold: 0.35,
          character_threshold: 0.85,
          replace_underscore: false,
          trailing_comma: false,
          exclude_tags: '',
          tags: 'simple_background, white_background, fingernails, realistic, fingers',
          image: [
            '61',
            0
          ]
        },
        class_type: 'WD14Tagger|pysssss',
        _meta: {
          title: 'WD14 Tagger 🐍'
        }
      }
    }
    const clientId = uuidv4()
    const data = {
      prompt: promptData,
      client_id: clientId
    }
    // 发送 Prompt 请求
    const sendPromptRequest = async () => {
      try {
        console.log('get prompt response', data)
        return genPrompt(data)
      } catch (error) {
        console.error('发送作图请求失败：', error)
      }
    }

    const fetchImageFilename = async (promptId) => {
      try {
        // 直接使用该实例请求历史记录
        const historyRequest = axios.create({
          baseURL: getLastUsedBaseUrl(),
          timeout: 5000,
          headers: {
            'Content-Type': 'application/json'
          }
        })

        const response = await historyRequest.get(`/history/${promptId}`)
        const promptInfo = response.data[promptId]
        const promptIndex = 2 // prompt信息的下标
        if (promptInfo.status.status_str === 'success') {
          const img1 = JSON.parse(promptInfo.prompt[promptIndex][51].inputs.filename)
          const img2 = JSON.parse(promptInfo.prompt[promptIndex][55].inputs.filename)
          const img3 = JSON.parse(promptInfo.prompt[promptIndex][56].inputs.filename)
          const img4 = JSON.parse(promptInfo.prompt[promptIndex][57].inputs.filename)
          const temp = [img1[0], img2[0], img3[0], img4[0]]
          temp.forEach(async (item) => {
            const imagepath = genOssImage(item)
            imageList.push(imagepath)
          })
        } else {
          console.error('获取历史记录失败，状态码：', response.status)
        }
        return imageList
      } catch (error) {
        console.error('获取图像文件名失败：', error)
      }
    }

    const listenToProgress = (promptId) => {
      const ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${clientId}`)
      const wsTimeout = setTimeout(() => {
        Message.warning('网络连接超时,请重新尝试!')
        ws.close()
      }, 2000)

      ws.onopen = () => {
        console.log('提交服务器开始生成...')
        clearTimeout(wsTimeout)
      }
      ws.onmessage = async (event) => {
        clearTimeout(wsTimeout)
        const data = event.data
        if (typeof data === 'string') {
          try {
            const msg = JSON.parse(event.data)
            if (msg.type === 'executing') {
              const data = msg.data
              if (data.node === null && data.prompt_id === promptId) {
                ws.close()
                const images = await fetchImageFilename(promptId)
                // 返回对象
                const obj = {
                  images: images,
                  status: false
                }
                resolve(obj)
              }
            } else if (msg.type === 'progress') {
              const value = msg.data.value
              const max = msg.data.max
              const current = (value / max * 100).toFixed(2)
              if (progressCallback && typeof progressCallback === 'function') {
                progressCallback(current)
              }
            }
          } catch (error) {
            console.log('获取结果失败，请重试')
          }
        }
      }
      ws.onerror = (error) => {
        reject(error)
      }
      ws.onclose = async () => {
        try {
          const index = cudaIndexNum()
          await cuda.changeCudaCurrentStatus(index, 'leisure')
        } catch (error) { console.log(error) }
      }
    }

    (async () => {
      const result = await sendPromptRequest()
      if (result && result.prompt_id) {
        listenToProgress(result.prompt_id)
      }
    })()
  })
}

export {
  commonsdxl
}
